$(function() {
  // textarea
  const maxHeight = 74
  $('.js-textarea-footer-textarea').on('input', function() {
    this.style.height = ''
    this.style.height = Math.min(this.scrollHeight, maxHeight) + 'px'
  })
})
